import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15616334"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "login_qrcode_container"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "wwLogin_qrcode_tips"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://wwcdn.weixin.qq.com/node/wework/images/IconWarn.ebf07b08cd.svg",
  class: "wwLogin_qrcode_tips_icon"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "二维码已过期", -1));
const _hoisted_6 = {
  key: 1,
  class: "wwLogin_qrcode_tips"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "wwLogin_qrcode_tips_cnt"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://wwcdn.weixin.qq.com/node/wework/images/IconSuc.75ddbc3336.svg",
  class: "wwLogin_qrcode_tips_icon"
}), /*#__PURE__*/_createElementVNode("h4", null, "扫码成功"), /*#__PURE__*/_createElementVNode("p", null, "正在登录...")], -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login_qrcode_text"
}, "请使用微信扫描二维码登录", -1));
import { ElMessage } from 'element-plus';
import { OAuthController } from '@/api/system/index';

import { ref, onMounted, onUnmounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  ...{
    name: 'WeChatLogin'
  },
  __name: 'login',
  props: {
    bindSocial: {
      type: Boolean,
      default: false
    },
    dialog: {}
  },
  emits: ['success', 'error'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const expired = ref(false);
    const scaned = ref(false);
    const qrCodeUrl = ref(null);
    const ticket = ref(null);
    const timer = ref(null);
    const refreshQrCode = () => {
      stopCheckStatu();
      OAuthController.getWechatQrCode().then(res => {
        if (res.success) {
          qrCodeUrl.value = res.data.qrCodeUrl;
          ticket.value = res.data.ticket;
          expired.value = false;
          setTimeout(() => {
            expired.value = true;
            stopCheckStatu();
          }, (res.data.expireSeconds - 2 || 58) * 1000);
          checkStatus();
        }
      });
    };
    const checkStatus = () => {
      if (ticket.value) {
        timer.value = setInterval(() => {
          OAuthController.checkWechatStatus({
            ticket: ticket.value
          }, {
            showMask: false
          }).then(res => {
            scaned.value = res.data;
            if (scaned.value) {
              doLogin();
              stopCheckStatu();
            }
          });
        }, 5000);
      }
    };
    const stopCheckStatu = () => {
      if (timer.value) {
        clearInterval(timer.value);
        ticket.value = null;
        console.log('stopCheckStatu');
      }
    };
    const doLogin = () => {
      if (props.bindSocial) {
        OAuthController.bind({
          source: 'wechat',
          code: ticket.value
        }).then(res => {
          console.log('微信绑定成功', res);
          if (props.dialog) {
            ElMessage.success('绑定成功');
            props.dialog.submit(res);
          }
          emit('success', res);
        }).catch(e => {
          emit('error', e);
        });
      } else {
        OAuthController.login({
          source: 'wechat',
          code: ticket.value
        }).then(res => {
          console.log('微信登录成功', res);
          if (props.dialog) {
            props.dialog.submit(res);
          }
          emit('success', res);
        }).catch(e => {
          console.warn('微信登录失败');
          emit('error', e);
        });
      }
    };
    onMounted(() => {
      refreshQrCode();
    });
    onUnmounted(() => {
      stopCheckStatu();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        class: "wwLogin_qrcode_img",
        src: _unref(qrCodeUrl)
      }, null, 8, _hoisted_2), _unref(expired) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
        class: "wwLogin_qrcode_tips_cnt"
      }, [_hoisted_4, _hoisted_5, _createElementVNode("a", {
        href: "javascript:;",
        onClick: refreshQrCode
      }, "刷新")])])) : _createCommentVNode("", true), _unref(scaned) ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true)]), _hoisted_9]);
    };
  }
});